import { CustomHeader } from "@/components/CustomHeader";
import { ThemedText } from "@/components/ThemedText";
import { ThemedView } from "@/components/ThemedView";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

export default function AreaReportScreen() {
  const { t } = useTranslation();
  return (
    <ThemedView style={styles.container}>
      <CustomHeader title={t("AREA_REPORT_TITLE")} showBackButton />
      <ThemedView style={styles.body}>
        <ThemedText style={styles.message}>
          {t("AREA_REPORT_UNAVAILABLE_ON_PLATFORM")}
        </ThemedText>
      </ThemedView>
    </ThemedView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  body: { flex: 1, alignItems: "center", justifyContent: "center", padding: 24 },
  message: { fontSize: 15, textAlign: "center", opacity: 0.7 },
});
